import PaymentLink from "./orders/payment-link";
import { ShippingTracking } from "./orders/tranking";
import Credit from "./settings/credit";
import Settings from "./settings/settings";
import ManualRenewal from "./subscriptions/manual-renewal";
import RetryRenewal from "./subscriptions/retry-renewal";
import PaymentMethodDiscount from "./settings/payment-method-discount";
import PaymentProfile from "./subscriptions/payment-profile";
import MultiPaymentMinControl from "./settings/multipayment-min-control";
import VindiPagamentosAdminConfig from "./config";


document.addEventListener("DOMContentLoaded", () => {
  new Settings();
  new Credit();
  new ShippingTracking();
  new PaymentLink();
  new ManualRenewal();
  new RetryRenewal();
  new PaymentMethodDiscount();
  new PaymentProfile();
  new MultiPaymentMinControl();
  new VindiPagamentosAdminConfig();
});
